import { Action } from "redux";


interface IMetadataReducerProps {
    fetchStartActionName: string;
    fetchSuccessActionName: string;
    fetchErrorActionName: string;
}

export interface IMetadataReducerState {
    fetchRunning?: boolean;
    fetchStartedAt?: number;
    fetchCompletedAt?: number;
    fetchErrorAt?: number;
    fetchError?: Error | null;
}



export const generateMetadataReducer = (props: IMetadataReducerProps): Function => ((action: Action): object => {

    switch (action.type) {
        case props.fetchStartActionName: {
            return {
                fetchRunning: true,
                fetchStartedAt: Date.now(),
            };
        }
        case props.fetchSuccessActionName: {
            return {
                fetchRunning: false,
                fetchCompletedAt: Date.now(),
                fetchErrorAt: null,
                fetchError: null,
                // @ts-ignore
                ...action.payload,
            };
        }
        case props.fetchErrorActionName: {
            return {
                fetchRunning: false,
                fetchErrorAt: Date.now(),
                // @ts-ignore
                fetchError: action.error,
            };
        }
        default:
            return {};
    }

});
